import { render } from "./tablaLista.vue?vue&type=template&id=97e397a0"
import script from "./tablaLista.vue?vue&type=script&lang=js"
export * from "./tablaLista.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__